import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import { Box } from "@mui/system";
import GoalTile from "../../../common/components/GoalTile/GoalTile";
import CreateGoalModalController from "../../../common/Modals/PerofomanceModals/CreateGoalModal/CreateGoalModalController";

interface propsType {
  trans?: any;
  handleTriggerShowDeatil?: any;
}
const GoalsPresenter: React.FC<propsType> = ({
  trans,
  handleTriggerShowDeatil,
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div>
      <CustomAddActionCard
        card_title={trans("Goals")}
        card_subtitle={`${trans("Total")} `}
        card_height="310px"
        onClick={() => setOpenModal(true)}
        isAddButton={true}
      >
        <Box style={{ marginBottom: "24px" }} />

        <div>
          <GoalTile
            goalName={"Skill"}
            daysLeft="3"
            goalProgress="85"
            onClick={() =>
              handleTriggerShowDeatil({ data: null, isOpen: true })
            }
          />
          <Box style={{ marginTop: "1em" }} />
          <GoalTile
            goalName={"Skill"}
            daysLeft="3"
            goalProgress="85"
            onClick={() =>
              handleTriggerShowDeatil({ data: null, isOpen: true })
            }
          />
        </div>
      </CustomAddActionCard>

      {openModal && (
        <CreateGoalModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          trans={trans}
        />
      )}
    </div>
  );
};

export default GoalsPresenter;
